import { useState, useCallback, useRef } from "react"
import { useTranslation } from "react-i18next";

export const useErrorInputs = (initialState = {}) => {
    const { t } = useTranslation();
    const tRef = useRef(t);
    tRef.current = t;

    const [errorInputs, setErrorInputs] = useState(initialState);

    const resetErrors = useCallback(() => {
        setErrorInputs(initialState);
    }, [initialState]);

    const getNestedValue = (obj, path) => {
        if (!path) return undefined;
        return path.split('.').reduce((acc, part) => {
            if (!acc) return undefined;

            if (part.includes('[')) {
                const [key, index] = part.split(/\[|\]/).filter(Boolean);
                return acc[key]?.[Number(index)];
            }

            return acc[part];
        }, obj);
    };

    const handleErrorInput = useCallback((input, { isError = false, messageError = '' }) => {
        setErrorInputs((prevErrorInputs) => {
            const currentError = prevErrorInputs[input];
            if (currentError?.isError === isError && currentError?.messageError === messageError) {
                return prevErrorInputs;
            }
            return {
                ...prevErrorInputs,
                [input]: {
                    isError,
                    messageError
                }
            };
        });
    }, []);

    const validateFields = useCallback((fields, data) => {
        const translate = tRef.current;
        let valid = true;
        const newErrors = {};

        fields.forEach((item) => {
            const value = getNestedValue(data, item);
            const isEmpty = value === '' || value === undefined ||
                (typeof value === 'string' && value.trim() === '') ||
                (Array.isArray(value) && value.length === 0);

            if (isEmpty) {
                newErrors[item] = { isError: true, messageError: translate("validation.requiredField") };
                valid = false;
            } else {
                newErrors[item] = { isError: false, messageError: '' };
            }
        });

        setErrorInputs(newErrors);
        return valid;
    }, []);

    const validForm = useCallback((fields, data) => {
        return validateFields(fields, data);
    }, [validateFields]);

    return [errorInputs, handleErrorInput, resetErrors, validForm, validateFields];
}